'use client';
import { Loader, Sidebar } from 'components/common';
import Search from 'components/common/Search';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDTO, SecondaryFilter } from '../types';
import { getListSecondaryForms } from '../services/formServices';
import { useSidebarManager } from 'contexts/SidebarManagerContext';
import EditResponse from './FormResponses/EditResponse';
import { useAuthContext } from 'contexts/AuthContext';

const SecondaryForms = ({
  sidebar,
  setSidebarWidth,
  sidebarWidth,
  //   params,
}: SideBarProps<{
  formId: string;
  responseId?: number;
  withUser?: boolean;
}>) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { openSidebar, closeSidebar } = useSidebarManager();
  const [secondaryForms, setSecondaryForms] = useState<FormDTO[]>([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState<SecondaryFilter>({
    searchValue: '',
    lenght: 10,
    currentList: 0,
    id: 0,
    roleName: '',
    userid: '',
    roleId: '',
    ids: [],
    assigend: true,
    selectAll: true,
    isGroup: true,
    isApprovalEvpLevel: true,
  });

  const fetchSecondaryForms = async () => {
    try {
      setLoading(true);
      const response = await getListSecondaryForms(filter);
      setSecondaryForms(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSecondaryForms();
  }, [filter]);

  const handleSearch = (value: string) => {
    setFilter({ ...filter, searchValue: value });
  };

  return (
    <Sidebar
      size="m"
      type="primary"
      sidebar={sidebar}
      setSidebarWidth={setSidebarWidth}
      sidebarWidth={sidebarWidth}
    >
      <div className="minthr-flex minthr-flex-items-center  minthr-py-2 minthr-border-b minthr-border-b-3">
        <h3>{t('Form.Title')}</h3>
        <button
          className="minthr-sidebar-close"
          type="button"
          onClick={() => closeSidebar(SecondaryForms)}
        >
          <img className="minthr-icon-gray" src="/icons/close.svg" alt="" />
        </button>
      </div>
      <div className="minthr-mt-6">
        <div className="minthr-searchbar minthr-mb-4">
          <Search
            inputClassName="w-100 search"
            onSearch={handleSearch}
            placeholder={t('Search')}
          />
        </div>

        <div id="ListScrole" className="minthr-mb-6 minthr-h-80">
          {loading ? (
            <Loader />
          ) : (
            <div id="newUser" className="tw-flex tw-flex-col tw-gap-2">
              {secondaryForms.map((form) => (
                <a
                  key={form.id}
                  className="tw-w-full minthr-btn minthr-btn-white minthr-flex-justify-start minthr-py-2 minthr-pl-3 minthr-border minthr-border-3 minthr-pointer cursor-pointer tw-flex tw-items-center tw-no-underline tw-transition-all hover:tw-bg-primary/5"
                  onClick={() => {
                    openSidebar(EditResponse, true, {
                      formId: form.id,
                      responseId: 0,
                      userId: user.userId as string,
                      withUser: true,
                    });
                  }}
                >
                  <div className="minthr-mr-3">
                    <i
                      className={`minthr-mr-0 fa-solid ${form.iconPath?.includes('fa-') ? form.iconPath : 'fa-file'}`}
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div className="tw-flex-1 tw-min-w-0">
                    <h5 className="tw-truncate">{form.title}</h5>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </Sidebar>
  );
};

export default SecondaryForms;
